export default {"src":"/_next/static/media/sort.b16ca329.svg","height":24,"width":24};